import {Injectable} from '@angular/core';
import {Http, Headers} from '@angular/http';
import {MainService} from './main.service';
import {DatePipe} from '@angular/common';

@Injectable()
export class PositionService {

    constructor(public http: Http, public mainService: MainService, private datePipe: DatePipe) {
    }

    edit(position: any) {
        let promise = new Promise((resolve, reject) => {
            this.http.put(this.mainService.server_url + 'position/id;idPosition=' + position.idPosition + ';idDevice=' + position.idDevice, position)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    getLastPosition(idDevice: String) {
        let promise = new Promise((resolve, reject) => {
            this.http.get(this.mainService.server_url + 'position/' + idDevice)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    getLastPositions(idDevice: String, numberPositions: number) {
        let request = {idDevice: idDevice, numberPositions: numberPositions};
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/getLastPositions', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findBetweenDates(idDevice: String, initialDate: Date, finalDate: Date, first: number, pageSize: number) {
        let request = {
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss'),
            idDevice: idDevice, first: first, pageSize: pageSize
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findBetweenDates', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findDriverTravels(initialDate: Date, finalDate: Date, idDriver: number, filter: String, idUser: string) {
        let request = {
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idDriver: idDriver, filter: filter, idUser: idUser
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findDriverTravels', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findRange(idDevice: String, idPositionStart: number, idPositionFinal: number) {
        let request = {
            idPositionStart: idPositionStart,
            idPositionFinal: idPositionFinal,
            idDevice: idDevice
        };
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findRange', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    countFindBetweenDates(idDevice: String, initialDate: Date, finalDate: Date) {
        let request = {
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss'), idDevice: idDevice
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/countFindBetweenDates', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findStoppedTimes(idDevice: String, initialDate: Date, finalDate: Date, duration: number, filter: String) {
        let request = {
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idDevice: idDevice,
            duration: duration,
            filter: filter
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findStoppedTimes', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findTravels(idDevice: String, initialDate: Date, finalDate: Date, filter: String) {
        let request = {
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idDevice: idDevice, filter: filter
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findTravels', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findDistanceFuelConsumption(idDevice: String, initialDate: Date, finalDate: Date, groupBy: String) {
        let request = {
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idDevice: idDevice, groupBy: groupBy
        }

        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findDistanceFuelConsumption', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findBySpeed(idDevice: String, initialDate: Date, finalDate: Date, speed: number) {
        let request = {
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idDevice: idDevice, speed: speed
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findBySpeed', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findByLeisure(idDevice: String, initialDate: Date, finalDate: Date, duration: number) {
        let request = {
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idDevice: idDevice,
            duration: duration
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findByLeisure', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findAlarm(idDevice: String, initialDate: Date, finalDate: Date, idAlarmType: String) {
        let request = {
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idDevice: idDevice, idAlarmType: idAlarmType
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findAlarm', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findDriverAlarms(idDriver: number, initialDate: Date, finalDate: Date, idUser: String) {
        let request = {
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idDriver: idDriver, idUser: idUser
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findDriverAlarms', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findDrivingOutsideHours(idDevice: String, initialDate: Date, finalDate: Date) {
        let request = {
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idDevice: idDevice
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findDrivingOutsideHours', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findByStatus(idDevice: String, initialDate: Date, finalDate: Date, duration: number, filter: String) {
        let request = {
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idDevice: idDevice,
            duration: duration,
            filter: filter
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findByStatus', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    getSummaryInfractions(initialDate: Date, finalDate: Date, idUser: String) {
        let request = {
            startDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            endDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idUser: idUser
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/getSummaryInfractions', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    getSummaryDistanceTraveled(initialDate: Date, finalDate: Date, idUser: String) {
        let request = {
            startDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            endDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idUser: idUser
        }
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/getSummaryDistanceTraveled', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    getSummaryInfractionsByDay(idDevice: String, initialDate: Date, finalDate: Date) {
        let request = {
            startDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            endDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            idDevice: idDevice
        };
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/getSummaryInfractionsByDay', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }

    findGeofenceEvents(idDevice: String, idGeofence: number, initialDate: Date, finalDate: Date, idUser: String) {
        let request = {
            idDevice: idDevice,
            idGeofence: idGeofence,
            idUser: idUser,
            initialDate: this.datePipe.transform(initialDate, 'dd/MM/yyyy HH:mm:ss', 'UTC'),
            finalDate: this.datePipe.transform(finalDate, 'dd/MM/yyyy HH:mm:ss', 'UTC')
        };
        let promise = new Promise((resolve, reject) => {
            this.http.post(this.mainService.server_url + 'position/findGeofenceEvents', request)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    },
                    msg => { // Error
                        reject(msg);
                    }
                );
        });
        return promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/position.service.ts